import {
  activateIdentifier,
  inactiveIdentifier,
  replaceIdentifier,
  newIdentifier
} from '../services/activationService'

import types from './types'

const { ACTIVATION_IDENTIFIER, INACTIVE_IDENTIFIER, REPLACE_IDENTIFIER, NEW_IDENTIFIER } = types

export function fetchActivation(data) {
  return dispatch =>
    activateIdentifier(data).then(activation => {
      dispatch({
        type: ACTIVATION_IDENTIFIER,
        state: null
      })

      return activation
    })
}

export function fetchActivationForPartners(data) {
  return dispatch =>
    activateIdentifier(data).then(() => {
      dispatch({
        type: ACTIVATION_IDENTIFIER,
        state: null
      })

      return data
    })
}

export function fetchInactiveIdentifier(data) {
  return dispatch =>
    inactiveIdentifier(data).then(activation => {
      dispatch({
        type: INACTIVE_IDENTIFIER,
        state: null
      })

      return activation
    })
}

export function fetchReplaceIdentifier(data) {
  return dispatch =>
    replaceIdentifier(data).then(activation => {
      dispatch({
        type: REPLACE_IDENTIFIER,
        state: null
      })

      return activation
    })
}

export function fetchNewIdentifier(data) {
  return dispatch =>
    newIdentifier(data).then(identifier => {
      dispatch({
        type: NEW_IDENTIFIER,
        state: null
      })
      return identifier
    })
}



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/activation.js